import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="B" transform="translate(11.000000, 5.000000)">
        <path d="M39 0L0 22V67L39 90L78 68V23L39 0Z" fill="black" />
        <path
          d="M39.96 66.42C36.88 66.42 34.12 65.92 31.68 64.92C29.24 63.92 27.28 62.44 25.8 60.48C24.36 58.52 23.6 56.16 23.52 53.4H34.44C34.6 54.96 35.14 56.16 36.06 57C36.98 57.8 38.18 58.2 39.66 58.2C41.18 58.2 42.38 57.86 43.26 57.18C44.14 56.46 44.58 55.48 44.58 54.24C44.58 53.2 44.22 52.34 43.5 51.66C42.82 50.98 41.96 50.42 40.92 49.98C39.92 49.54 38.48 49.04 36.6 48.48C33.88 47.64 31.66 46.8 29.94 45.96C28.22 45.12 26.74 43.88 25.5 42.24C24.26 40.6 23.64 38.46 23.64 35.82C23.64 31.9 25.06 28.84 27.9 26.64C30.74 24.4 34.44 23.28 39 23.28C43.64 23.28 47.38 24.4 50.22 26.64C53.06 28.84 54.58 31.92 54.78 35.88H43.68C43.6 34.52 43.1 33.46 42.18 32.7C41.26 31.9 40.08 31.5 38.64 31.5C37.4 31.5 36.4 31.84 35.64 32.52C34.88 33.16 34.5 34.1 34.5 35.34C34.5 36.7 35.14 37.76 36.42 38.52C37.7 39.28 39.7 40.1 42.42 40.98C45.14 41.9 47.34 42.78 49.02 43.62C50.74 44.46 52.22 45.68 53.46 47.28C54.7 48.88 55.32 50.94 55.32 53.46C55.32 55.86 54.7 58.04 53.46 60C52.26 61.96 50.5 63.52 48.18 64.68C45.86 65.84 43.12 66.42 39.96 66.42Z"
          fill="#64FFDA"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
